{
  "meta": {
    "title": "AmberBytes — Mästare på mjukvara",
    "description": "AmberBytes bygger snabb, pålitlig och människocentrerad mjukvara för ambitiösa team."
  },
  "nav": {
    "services": "Tjänster",
    "about": "Om oss",
    "tech": "Teknik",
    "contact": "Kontakt"
  },
  "hero": {
    "headline": "Vi förvandlar råa idéer till polerad mjukvara.",
    "subheadline": "AmberBytes är en tight teknikkonsultbyrå som designar, bygger och levererar digitala produkter med tydlighet och fart.",
    "cta": "Starta ett projekt"
  },
  "services": {
    "title": "Vad vi gör",
    "subtitle": "Helhetskompetens för produkter, från första skiss till produktionsskala.",
    "items": [
      {
        "title": "Produktstrategi",
        "description": "Vi hjälper dig hitta signalen i bruset och definiera en produkt dina användare älskar."
      },
      {
        "title": "Webbapplikationer",
        "description": "Moderna, tillgängliga och presterande gränssnitt byggda med React, TypeScript och Tailwind."
      },
      {
        "title": "Backendsystem",
        "description": "Robusta API:er, molninfrastruktur och datapipelines som skalar med din verksamhet."
      },
      {
        "title": "Teamförstärkning",
        "description": "Seniora ingenjörer inbäddade i ditt team för att snabba på leveransen och höja ribban."
      }
    ]
  },
  "about": {
    "title": "Varför AmberBytes?",
    "paragraphs": [
      "Vi tror att fantastisk mjukvara föds ur nyfikenhet, disciplin och nära samarbete. Varje projekt börjar med att lyssna.",
      "Vårt team har levererat produkter för startups, scale-ups och stora företag inom fintech, healthtech och digital handel.",
      "Vi bryr oss om ren arkitektur, snabba feedback-loopar och design som faktiskt fungerar för riktiga människor."
    ]
  },
  "tech": {
    "title": "Verktyg vi älskar",
    "subtitle": "Vi väljer rätt stack för uppgiften — det här är vad vi oftast tar till."
  },
  "contact": {
    "title": "Låt oss bygga något amber.",
    "subtitle": "Berätta vad du jobbar med. Vi återkommer inom två arbetsdagar.",
    "name": "Namn",
    "email": "E-post",
    "message": "Meddelande",
    "send": "Skicka meddelande",
    "success": "Tack — vi hör av oss snart.",
    "emailLabel": "Eller skriv direkt till"
  },
  "footer": {
    "rights": "© {year} AmberBytes. Alla rättigheter förbehållna.",
    "language": "Språk"
  }
}
